import { render } from "./CWaiting.vue?vue&type=template&id=6065d724&scoped=true"
import script from "./CWaiting.vue?vue&type=script&lang=js"
export * from "./CWaiting.vue?vue&type=script&lang=js"

import "./CWaiting.vue?vue&type=style&index=0&id=6065d724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6065d724"]])

export default __exports__